import { render, staticRenderFns } from "./grading.vue?vue&type=template&id=4b6d54b2&scoped=true&"
import script from "./grading.vue?vue&type=script&lang=js&"
export * from "./grading.vue?vue&type=script&lang=js&"
import style0 from "./grading.vue?vue&type=style&index=0&id=4b6d54b2&lang=scss&scoped=true&"
import style1 from "./grading.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./grading.vue?vue&type=style&index=2&id=4b6d54b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d54b2",
  null
  
)

export default component.exports